import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0eaefa21")

_pushScopeId("data-v-0eaefa21")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex kn-flex"
}
const _hoisted_2 = { class: "timespan-interval-calendar p-fluid kn-flex" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "timespan-interval-calendar p-fluid  kn-flex p-mx-auto" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { class: "kn-material-input-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_ctx.timespan)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.interval.from,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.interval.from = $event)),
              manualInput: true,
              timeOnly: _ctx.timespan.type === 'time',
              hourFormat: "24"
            }, null, 8, ["modelValue", "timeOnly"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.from')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.interval.to,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.interval.to = $event)),
              manualInput: true,
              timeOnly: _ctx.timespan.type === 'time',
              hourFormat: "24"
            }, null, 8, ["modelValue", "timeOnly"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.to')), 1)
          ])
        ]),
        _createVNode(_component_Button, {
          id: "timespan-interval-add-button",
          class: "kn-button kn-button--primary p-ml-auto",
          disabled: _ctx.addButtonDisabled,
          onClick: _ctx.onAddInterval,
          "data-test": "add-button"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
})